<template>
	<van-popup
		v-model:show="displayPopup"
		position="center"
		:style="{ width: '100%', borderRadius: '15px' }"
		:overlay="true"
		:close-on-click-overlay="type == 'recording'"
		@update:show="closePopup"
		@closed="onClosed"
		:overlay-style="{ background: 'rgba(86, 86, 86, 0.5)', backdropFilter: 'blur(10px)' }"
		:z-index="30000"
	>
		<div class="spacer"></div>

		<van-row justify="center" style="margin:15px 0;">
			<van-loading v-if="type == 'loading'" color="#0d250b" size="40px"></van-loading>
			<img v-if="type == 'success' && message !=''" :src="successIcon" width="62px" height="62px" />
			<img v-if="type == 'error' && message !=''" :src="warningIcon" width="62px" height="62px" />
			<img v-if="type == 'future' && message !=''" :src="comingSoonIcon" width="62px" height="62px" />
			<van-icon name="volume-o" size="62px" v-if="type == 'recording'" color="#0d250b"></van-icon>
		</van-row>
		<van-row justify="center" style="margin-bottom:15px ;">
			<span v-if="message != ''" style="color: #000000; font-size: 13px; text-align: center;">
				{{ message }}
			</span>
		</van-row>

	</van-popup>
</template>

<script>
export default {
	name: "statusPopup",
	data() {
		return {
			message: "",
			displayPopup: false,
			type: '',
			successIcon: '/common/success_icon.png',
			warningIcon: '/common/warning_icon.png',
			comingSoonIcon: '/common/coming_soon.png',
			autoCloseTimer: null, // tracks the pending auto-close so it can be cancelled
			popupSequence: 0,
		};
	},
	beforeUnmount() {
		this.clearAutoCloseTimer();
	},
	methods: {
		show() {
			this.beginPopup();
			this.displayPopup = true;
		},
		beginPopup() {
			this.clearAutoCloseTimer();
			this.popupSequence += 1;
			return this.popupSequence;
		},
		clearAutoCloseTimer() {
			if (this.autoCloseTimer) {
				clearTimeout(this.autoCloseTimer);
				this.autoCloseTimer = null;
			}
		},
		closePopup(show) {
			if (!show) {
				this.clearAutoCloseTimer();
				this.popupSequence += 1;
				this.displayPopup = false;
			}
		},
		onClosed() {
			if (!this.displayPopup) {
				this.type = '';
				this.message = '';
			}
		},
		closeRecording() {
			this.$emit('closeRecord');
		},
		scheduleAutoClose(callback, sequence) {
			// Always cancel a previous pending timer first
			this.clearAutoCloseTimer();
			this.autoCloseTimer = setTimeout(() => {
				this.autoCloseTimer = null;
				if (sequence !== this.popupSequence) return;
				this.closePopup(false);
				if (callback) callback();
			}, 1500);
		},
		//message -required
		success(message, callback) {
			const sequence = this.beginPopup();
			this.type = 'success';
			this.message = message;
			this.displayPopup = true;
			this.scheduleAutoClose(callback, sequence);
		},
		loading() {
			this.beginPopup();
			this.type = 'loading';
			this.message = '';
			this.displayPopup = true;
		},
		stopLoading() {
			this.closePopup(false);
		},
		recording(message, callback) {
			this.beginPopup();
			this.type = 'recording';
			this.message = message || '';
			this.displayPopup = true;
		},
		stopRecording() {
			this.closePopup(false);
		},
		//to popup error message
		//message -required
		error(message, callback) {
			const sequence = this.beginPopup();
			this.type = 'error';
			this.message = message;
			this.displayPopup = true;
			this.scheduleAutoClose(callback, sequence);
		},
		future(message, callback) {
			const sequence = this.beginPopup();
			this.type = 'future';
			this.message = message;
			this.displayPopup = true;
			this.scheduleAutoClose(callback, sequence);
		},
	}
};
</script>

<style scoped>
.spacer {
	height: 20px;
}
</style>
